import { useMemo } from "react";

import {
  useProductOutput,
  useTechnicalDesignInputMode,
  type OrderCodePart,
  TechnicalDesignInputModes,
} from "stores/product";

export const useIsPartDisabled = (part: OrderCodePart) => {
  const technicalDesignInputMode = useTechnicalDesignInputMode();
  const productOutput = useProductOutput();

  const iterablePartsSet = useMemo(() => {
    const iterableParts =
      productOutput?.product?.listViewConfiguration?.iterableParts;
    if (iterableParts === null || iterableParts === undefined) {
      return new Set<string>();
    }
    return new Set(
      iterableParts.flatMap(
        (p) => p?.options?.map((o) => `${p.partKey}-${o?.optionKey}`) ?? [],
      ),
    );
  }, [productOutput]);

  const isDisabled = useMemo(() => {
    if (technicalDesignInputMode !== TechnicalDesignInputModes.RESULT_LIST) {
      return false;
    }
    const iterableParts =
      productOutput?.product?.listViewConfiguration?.iterableParts;
    if (iterableParts === null || iterableParts === undefined) {
      return false;
    }
    if (iterableParts.length === 0) {
      return true;
    }

    const displayablePartOptions = part.options?.filter(
      (option) =>
        option?.state !== null &&
        option?.state !== undefined &&
        option.state === 0,
    );

    let allOptionsDisabled = true;
    for (const option of displayablePartOptions ?? []) {
      if (!iterablePartsSet.has(`${part.key}-${option?.key}`)) {
        allOptionsDisabled = false;
        break;
      }
    }

    return allOptionsDisabled;
  }, [part, productOutput, technicalDesignInputMode, iterablePartsSet]);

  return isDisabled;
};
